import axios from 'axios';
import { AnalyticsMetadata } from '../utils/analytics';

export function create(
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  metadata: AnalyticsMetadata,
  companyName: string,
  phone: string,
) {
  const url = process.env.REACT_APP_CREATE_FREEMIUM_ACCOUNT_URL;
  const apiKey = process.env.REACT_APP_CREATE_FREEMIUM_ACCOUNT_API_KEY;

  if (!url) throw Error('REACT_APP_CREATE_FREEMIUM_ACCOUNT_URL undefined');
  if (!apiKey) throw Error('REACT_APP_CREATE_FREEMIUM_ACCOUNT_API_KEY undefined');
  const data = formatRequestData(firstName, lastName, email, password, metadata, companyName, phone);
  return axios.post(url, data, { headers: { 'Content-Type': 'application/json', 'X-Api-Key': apiKey } });
}

function formatRequestData(
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  metadata: AnalyticsMetadata,
  company: string,
  phone: string,
) {
  return {
    firstName,
    displayName: `${firstName} ${lastName}`.substring(0, 32),
    email,
    lastName,
    password,
    metadata,
    company,
    phone,
  };
}
